import React from 'react'

const CancelStripe = () => {
return (
    <h1 style={{ textAlign: "center", marginTop: "50px" }}>
      ❌ Płatność anulowana lub nieudana.
    </h1>
  );
}

export default CancelStripe
